import OrdersWorkspace from "@/components/OrdersWorkspace";

export default function Transfers() {
  return <OrdersWorkspace scope="transfer" />;
}
